var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0907 17.18L14.2776 23.9992L0.911865 16.2357V14.5414L12.7197 7.71692L26.0854 15.4856L26.0907 17.18Z",
    fill: "#1592D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.909424 14.5394L0.914231 16.2352L14.2757 24L14.2709 22.3043L0.909424 14.5394Z",
    fill: "#1592D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2708 22.3042L14.2756 24L26.0881 17.1801L26.0833 15.4843L14.2708 22.3042Z",
    fill: "#1592D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.909424 14.5393L14.2709 22.3042L26.0834 15.4842L12.722 7.71936L0.909424 14.5393Z",
    fill: "#1592D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6619 7.03538C21.7627 6.51182 20.5124 6.58573 19.1389 7.37413C16.4042 8.95704 14.193 12.7819 14.1992 15.9293L14.218 21.2156L2.6907 14.5208L2.67189 9.22825C2.66572 6.08704 4.87689 2.25604 7.61157 0.679288C8.98506 -0.115272 10.2354 -0.18918 11.1346 0.334375L22.6619 7.03538Z",
    fill: "#E9E7FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6615 7.03587C21.7612 6.51352 20.5109 6.58576 19.1384 7.37484C16.8044 8.73075 14.8484 11.7148 14.3316 14.5155L2.8064 7.81939C3.32319 5.01313 5.27926 2.02903 7.61316 0.678691C8.98575 -0.115953 10.2361 -0.188196 11.1363 0.334161L22.6615 7.03587Z",
    fill: "#1592D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1388 7.37713C21.8722 5.79899 24.0968 7.06674 24.1057 10.2104L24.1207 15.4991L14.2167 21.2172L14.2017 15.9285C14.1928 12.7849 16.4029 8.95667 19.1388 7.37713Z",
    fill: "#F3F1FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7576 15.9267C14.7492 12.9659 16.8393 9.34655 19.4167 7.85827C21.7399 6.51665 23.5426 7.44758 23.5503 10.2121L23.5644 15.8225L14.7698 20.8997L14.7576 15.9267Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3545 17.1067L16.9806 19.6281L16.9683 15.3307V14.4391L21.3373 11.9177L21.3545 17.1067Z",
    fill: "#1592D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8614 17.3942V17.3894L20.8424 12.7737L17.4639 14.7247V15.4212L20.8602 17.3949L20.8614 17.3942Z",
    fill: "#1592D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4639 15.4213V16.1951L17.4734 19.3452L20.8602 17.395L17.4639 15.4213Z",
    fill: "#1592D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30563 5.20114C8.52596 5.20114 7.89512 5.83198 7.89512 6.61165C7.89512 5.83185 7.26455 5.20114 6.48462 5.20114C7.2644 5.20114 7.89512 4.57056 7.89512 3.79065C7.89512 4.57042 8.52572 5.20114 9.30563 5.20114Z",
    fill: "#1592D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16324 13.3555L4.16846 10.4678L3.81702 10.2632L3.81177 13.5338L4.16324 13.3555Z",
    fill: "#DEDFFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16324 13.3555L3.81177 13.5338L7.7776 15.8207V15.4431L4.16324 13.3555Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16855 10.4678L4.16333 13.3555L7.77769 15.4431L7.78819 12.5606L4.16855 10.4678Z",
    fill: "#1592D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50748 16.4478L9.5127 13.5601L9.16126 13.3555L9.15601 16.6261L9.50748 16.4478Z",
    fill: "#DEDFFB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50748 16.4478L9.15601 16.6261L13.1218 18.913V18.5353L9.50748 16.4478Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51254 13.5601L9.50732 16.4478L13.1217 18.5353L13.1322 15.6529L9.51254 13.5601Z",
    fill: "#1592D2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3821 10.6273L20.3782 8.47283L20.6404 8.32019L20.6443 10.7604L20.3821 10.6273Z",
    fill: "#DEDFFB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3822 10.6273L20.6444 10.7604L17.6855 12.4666V12.1848L20.3822 10.6273Z",
    fill: "#F3F1FC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3783 8.47278L20.3822 10.6272L17.6856 12.1848L17.6777 10.0342L20.3783 8.47278Z",
    fill: "#1592D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFarm);
export default __webpack_public_path__ + "static/media/newFarm.b408707764361b66c6f1b3c9372164b9.svg";
export { ForwardRef as ReactComponent };